/* eslint-disable import/first */
import React from "react";
import { CRUD_MODELS, ROUTES } from "../constants";
import { useAuth0 } from "@auth0/auth0-react";

import async from "../components/Async";

import {
  Database,
  Home,
  Monitor,
  Users,
  FileText,
  Award,
  CreditCard,
  CheckSquare,
  Star,
  Tag,
  Upload,
  List,
  Repeat,
} from "react-feather";

import Landing from "../pages/presentation/Landing";
import * as inflector from "inflected";
import { CrudProvider } from "../CrudProvider";

// TODO MAYBE LAZY IMPORT
import Default from "../pages/dashboards/Default";
import AuthGuard from "../components/AuthGuard";
import CertificateHolders from "../pages/dashboards/data entry/CertificateHolders";
import Developments from "../pages/dashboards/data entry/Developments";

import LogEntry from "../pages/dashboards/data entry/LogEntry";
import DocumentTags from "../pages/dashboards/data entry/DocumentTags";
import BulkLotUpload from "../pages/dashboards/data entry/BulkLotUpload";
import SingleLotCertificateUpload from "../pages/dashboards/data entry/SingleLotCertificateUpload";

import CommonAreaIrrigationTrackingReport from "../pages/dataAccess/Reports/CommonAreaIrrigationTrackingReport";
import BulkLotTransfer from "../pages/dashboards/data entry/BulkLotTransfer";
import CertificatesOverview from "../pages/dataAccess/Reports/CertificatesOverviewReport";
import CertificatesTracking from "../pages/dataAccess/Reports/CertificatesTracking";
import DevelopmentsOverview from "../pages/dataAccess/Reports/DevelopmentsOverviewReport";
import Certificates from "../pages/dashboards/data entry/certificates";
import SingleLotsOverviewReport from "../pages/dataAccess/Reports/SingleLotsOverviewReport";
const Account = async(() => import("../pages/pages/Account"));
const Profile = async(() => import("../pages/pages/Profile"));

const CrudIndexPage = async(() => import("../components/crud/CrudIndexPage"));
const CrudViewPage = async(() => import("../components/crud/CrudViewPage"));

const getSidebarMenu = (list) => {
  return list.map((item) => {
    const slug = inflector.dasherize(inflector.underscore(item.name));
    return {
      id: item.sidebarName ?? inflector.titleize(item.name),
      path: `/models/${slug}`,
      model: inflector.singularize(item.name),
      icon: item.icon || <Database />,
      component: CrudIndexPage,
      config: require(`../pages/models/${item.name}Config`),
      provider: CrudProvider,
      children: item.children,
      header: item.header,
      guard: item.guard,
      visibilityFilter: item.visibilityFilter,
    };
  });
};

const getCrudRoutes = (list) => {
  return list.map((item) => {
    const config = require(`../pages/models/${item.name}Config`);
    const slug = inflector.dasherize(inflector.underscore(item.name));

    return {
      id: inflector.titleize(item.name),
      path: `/models/${slug}`,
      model: inflector.singularize(item.name),
      component: CrudIndexPage,
      provider: CrudProvider,
      config,
      crud: [
        {
          path: `/models/${slug}/:id`,
          name: `View ${inflector.titleize(inflector.singularize(item.name))}`,
          component: CrudViewPage,
          provider: CrudProvider,
          model: inflector.singularize(item.name),
          config,
        },
        {
          path: `/models/${slug}/add`,
          name: `Add ${inflector.titleize(inflector.singularize(item.name))}`,
          component: CrudViewPage,
          provider: CrudProvider,
          model: inflector.singularize(item.name),
          config,
        },
      ],
    };
  });
};

const crudSidebarMenu = [...getSidebarMenu(CRUD_MODELS)];
const modelCrudRoutes = [...getCrudRoutes(CRUD_MODELS)];

//Accounting ROUTES
const LogEntryRoute = {
  header: "Accounting",
  id: "Log Entry",
  icon: <CreditCard />,
  path: "/accounting/log-entry",
  name: "Log Entry",
  component: LogEntry,
  guard: AuthGuard,
};

const BulkLotTransferRoute = {
  id: "Bulk Lot Transfer",
  icon: <Repeat />,
  path: "/accounting/bulk-lot-transfer",
  name: "Bulk Lot Transfer",
  component: BulkLotTransfer,
  guard: AuthGuard,
};

const LotSetupRoute = {
  id: "Bulk Lot Upload",
  icon: <Upload />,
  path: "/accounting/bulk-lot-upload",
  name: "Bulk Lot Upload",
  component: BulkLotUpload,
  guard: AuthGuard,
};

const SingleLotCertificateRoute = {
  id: "Single Lot Certificate Upload",
  icon: <Upload />,
  path: "/accounting/single-lot-certificate-upload",
  name: "Single Lot Certificate Upload",
  component: SingleLotCertificateUpload,
  guard: AuthGuard,
};

//Accounting ROUTES

const CommonAreaIrrigationTrackingRoute = {
  header: "Reports",
  id: "Common Area Irrigation Tracking",
  icon: <CheckSquare />,
  path: "/reports/common-area-irrigation-tracking",
  name: "Common Area Irrigation Tracking",
  component: CommonAreaIrrigationTrackingReport,
  guard: AuthGuard,
};

const CertificatesRoutes = {
  id: "Certificates",
  icon: <FileText />,
  children: [
    {
      path: "/reports/certificates/certificates-overview",
      name: "Certificates Overview",
      component: CertificatesOverview,
    },
    {
      id: "Certificates Tracking",
      path: "/reports/certificates/certificates-tracking",
      name: "Certificates Tracking",
      component: CertificatesTracking,
    },
    {
      id: "Single Lots Overview",
      path: "/reports/certificates/single-lots-overview",
      name: "Single Lots Overview",
      component: SingleLotsOverviewReport,
    },
  ],
  guard: AuthGuard,
};

const DevelopmentsRoute = {
  id: "Developments",
  icon: <List />,
  path: "/reports/developments",
  name: "Developments",
  component: DevelopmentsOverview,
  guard: AuthGuard,
};

//LISTS  MANAGEMENT ROUTES
const certificateHoldersRoute = {
  header: "Lists Management",
  id: "Certificate Holders",
  icon: <Users />,
  path: "/lists-management/certificate-holders",
  name: "Certificate Holders",
  component: CertificateHolders,
  guard: AuthGuard,
};

const developmentsRoute = {
  id: "Developments",
  icon: <Home />,
  path: "/lists-management/developments",
  name: "Developments",
  component: Developments,
  guard: AuthGuard,
};

const certificatesRoute = {
  id: "Certificates",
  icon: <Award />,
  path: "/lists-management/certificates",
  name: "Certificates",
  component: Certificates,
  guard: AuthGuard,
};

const documentTagsRoute = {
  id: "Document Types",
  icon: <Tag />,
  path: "/lists-management/document-tags",
  name: "Document Types",
  component: DocumentTags,
  guard: AuthGuard,
};

const accountRoutes = {
  id: "Account",
  path: "/account",
  name: "Account",
  header: "Pages",
  icon: <Users />,
  component: Account,
  guard: AuthGuard,
  children: [
    {
      path: ROUTES.USER_PROFILE,
      name: "Profile",
      component: Profile,
    },
    {
      path: "/auth/logout",
      name: "Logout",
      component: function Logout() {
        const { logout } = useAuth0();
        logout();
      },
    },
  ],
};

const landingRoutes = {
  id: "Landing Page",
  path: "/",
  header: "Docs",
  icon: <Monitor />,
  component: Landing,
  children: null,
};

const mainRoutes = {
  header: "Dashboards",
  id: "Dashboard",
  path: "/dashboard",
  icon: <Star />,
  component: Default,
  children: null,
  containsHome: true,
  guard: AuthGuard,
};

// Routes using the Dashboard layout
export const dashboardLayoutRoutes = [
  mainRoutes,
  LogEntryRoute,
  BulkLotTransferRoute,
  LotSetupRoute,
  SingleLotCertificateRoute,
  CommonAreaIrrigationTrackingRoute,
  CertificatesRoutes,
  DevelopmentsRoute,
  certificateHoldersRoute,
  developmentsRoute,
  certificatesRoute,
  documentTagsRoute,
  accountRoutes,
];

export const dashboardMaxContentLayoutRoutes = [
  ...crudSidebarMenu,
  ...modelCrudRoutes,
];

// Routes using the Auth layout
export const authLayoutRoutes = [accountRoutes];

// Routes using the Presentation layout
export const presentationLayoutRoutes = [landingRoutes];

// Routes using the full screen map layout
export const fullscreenMapRoutes = [];

// Routes visible in the sidebar
export const sidebarRoutes = [
  mainRoutes,
  ...crudSidebarMenu,
  LogEntryRoute,
  BulkLotTransferRoute,
  LotSetupRoute,
  SingleLotCertificateRoute,
  CommonAreaIrrigationTrackingRoute,
  CertificatesRoutes,
  DevelopmentsRoute,
  certificateHoldersRoute,
  developmentsRoute,
  certificatesRoute,
  documentTagsRoute,
];
